var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var XHandleModel = require("./XHandleModel.js");
var XHandleView = require("./XHandleView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var XHandleController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};
lib_core.inherit(XHandleController, lib_core.Controller);
XHandleController.inject = {
    editor3d : Editor3d
};

module.exports = XHandleController;

XHandleController.prototype.handleId = "moveX";

XHandleController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new XHandleModel(editor3dModel, this.handleId, this.configuration);
};


XHandleController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new XHandleView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



